export function fetchPatientDocuments(aPatientId, aLimit, aOffset, aSearchString) {
  return (dispatch, getState) => {
    const company = getState().company && getState().company.company;

    return global.api.get('/api/patient_documents', {
      params:{
        company_id:company && company.id,
        patient_id:aPatientId,
        limit:aLimit,
        offset:aOffset,
        search:aSearchString
      }
    });
  };
}

export function uploadPatientDocument(aPatientId, aFile) {
  return (dispatch, getState) => {
    const company = getState().company && getState().company.company;
    const formData = new FormData();
    formData.append('company_id', company && company.id);
    formData.append('patient_id', aPatientId);
    formData.append('file', aFile, aFile.name);

    return global.api.post('/api/patient_documents', formData, {
      timeout:30000
    });
  };
}
